<template>
    <div class="page">
        <div class="search-wrapper">
            <el-row>
                <el-col :span="24">
                    <el-input v-model="search" placeholder="交易对" @input="handleSearch">
                        <template #append>
                            <el-button icon="Search" />
                        </template>
                    </el-input>
                </el-col>
            </el-row>
        </div>
        <div class="list-wrapper">
            <el-row class="item" v-for="(item, index) in usymbols" :key="index">
                <el-col :span="4">
                    <el-icon
                        :style="{ fontSize: '20px', color: item.iscollect ? '#ff9900' : '#909399', cursor: 'pointer' }"
                        @click="toggleCollect(item)">
                        <Star />
                    </el-icon>
                </el-col>
                <el-col :span="20">

                    <el-tag class="tagitem" :type="item.symbol === current.symbol ? 'primary' : 'info'"
                        :effect="item.symbol === current.symbol ? 'light' : 'plain'" @click="changeSymbol(item)">
                        <div class="circle" v-if="item.info.contractType === 'TRADIFI_PERPETUAL'"></div>
                        {{ item.name }}
                    </el-tag>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<style scoped>
.page {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.search-wrapper {
    flex-shrink: 0;
    /* 固定高度，不收缩 */
    padding: 20px;
    /* 根据需要调整内边距 */
}

.list-wrapper {
    flex: 1;
    /* 占据剩余空间 */
    overflow-y: auto;
    /* 超出显示滚动条 */
    padding: 0 16px;
    /* 根据需要调整内边距 */
}

.item {
    margin: 4px auto 8px auto;
    cursor: pointer;
}

.tagitem {
    position: relative;
    width: 100%;
    text-align: center;
    cursor: pointer;
}

.circle {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #F0B90B;
}
</style>

<script setup>
import { ref, reactive, onMounted, defineEmits } from 'vue'
import { ElMessage } from 'element-plus'
import { debounce } from 'lodash'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import { Helper } from '@/service'
import Database from '@/service/database'

const emit = defineEmits(["changeSymbol"])
const systemStore = useSystemStore()
const logStore = useLogStore()
const search = ref("")
const usymbols = reactive([])
const usymbolsBak = reactive(systemStore.usymbols)
const ucollect = reactive([])
const current = reactive(systemStore.currentusymbol)

onMounted(async () => {
    try {
        //读取收藏交易对
        let _ucollect = await Database.selectAll("UCollect")
        ucollect.splice(0, ucollect.length, ..._ucollect)
        usymbolsBak.forEach((e) => {
            e.iscollect = ucollect.findIndex(x => x.Symbol == e.name) > -1
            e.ascnumber = e.iscollect ? 1 : 0
            usymbols.push(e)
        })
        usymbols.sort((a, b) => {
            return b.ascnumber - a.ascnumber
        })
    } catch (error) {
        ElMessage.error("查询数据库出错:", error)
        logStore.addLog({
            title: '获取交易对失败',
            level: 'error',
            message: error
        })
    }
})

const handleSearch = () => {
    usymbols.length = 0

    if (search.value.length == 0) {
        usymbolsBak.forEach((e) => {
            e.iscollect = ucollect.findIndex(x => x.Symbol == e.name) > -1
            e.ascnumber = e.iscollect ? 1 : 0
            usymbols.push(e)
        })
    } else {
        handleSearchDebounce()
    }

    usymbols.sort((a, b) => {
        return b.ascnumber - a.ascnumber
    })
}

const handleSearchDebounce = debounce(function () {
    let _data = usymbolsBak.filter(x => x.name.indexOf(search.value.toUpperCase()) > -1)
    _data.forEach(e => {
        if (usymbols.findIndex(x => x.name == e.name) == -1) {
            e.iscollect = ucollect.findIndex(x => x.Symbol == e.name) > -1
            e.ascnumber = e.iscollect ? 1 : 0
            usymbols.push(e)
        }
    })
}, 500)

const toggleCollect = async (item) => {
    try {
        if (item.iscollect) {
            await Database.deleteWhere('UCollect', {
                index: 'Symbol',
                value: item.name
            })
        } else {
            await Database.insert('UCollect', {
                Id: Helper.NewId(),
                Symbol: item.name,
                Sort: 0
            })
        }
        item.iscollect = !item.iscollect
        item.ascnumber = item.iscollect ? 1 : 0
        usymbols.sort((a, b) => {
            return b.ascnumber - a.ascnumber
        })
    } catch (error) {
        ElMessage.error("操作失败:", error)
        logStore.addLog({
            title: '保存交易对失败',
            level: 'error',
            message: error
        })
    }
}

const changeSymbol = (data) => {
    if (data.symbol === current.symbol) return

    let _current = {
        name: data.name,
        symbol: data.symbol,
        amount: data.amount,
        price: data.price,
        binanceConfig: {
            marginType: data.binanceConfig.marginType,
            leverage: data.binanceConfig.leverage,
        },
        okxConfig: {
            marginType: data.okxConfig.marginType,
            crossLongLeverage: data.okxConfig.crossLongLeverage,
            crossShortLeverage: data.okxConfig.crossShortLeverage,
            isolatedLongLeverage: data.okxConfig.isolatedLongLeverage,
            isolatedShortLeverage: data.okxConfig.isolatedShortLeverage,
        },
    }

    systemStore.setCurrentusymbol(_current)
    systemStore.triggerChangeUsymbol()
    emit("changeSymbol")
}
</script>